<template>
  <Card size="large" id="rp-header">
    <View direction="column" gap="md">
      <View justify="start" gap="sm" align="center">
        <Avatar size="large" class="avatar" :userName="renter.user.name" />

        <Text variant="h2" wrap="nowrap">{{ renter.user.name }}</Text>
      </View>

      <View direction="column" gap="sm" v-if="showings.length">
        <template v-for="showing in showings" :key="showing.id">
          <ShowingRequestCard
            v-for="showingRequest in showing.showingRequests"
            :key="showingRequest.id"
            :property-id="showing.property.id"
            :property-address="showing.property.displayName"
            :property-photo="showing.property.coverImage"
            :showing-id="showing.id"
            :tour-type="showing.tourType"
            :showing-agent-id="defaultShowingAgentId || showing.showingAgent?.id"
            :showing-request-status="showingRequest.status"
            :showing-start-time="showing.startTime"
            :showing-end-time="showing.endTime"
            :showing-request="showingRequest"
          />
        </template>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, Text, Avatar, View } from '@tallo/design-system';
import { ShowingRequestCard } from '@tallo/investor/showing';
import { PropertyDto } from '@tallo/property';
import { RenterDto } from '@tallo/renter';

import { useRenterShowings } from '../composables/renter-showings';

const props = defineProps<{ renter: RenterDto; property: PropertyDto }>();

const { showings } = useRenterShowings();

const defaultShowingAgentId = computed(() => props.property.lastShowingAgentId);
</script>

<style scoped lang="scss"></style>
